<template>
  <div class="documents-section">
    <button @click="toggle" class="buttonScroll">
      <h3 class="left-span">{{ title }}</h3>
      <ChevronDownIcon :size="45" :class="{ rotated: isActive }" />
    </button>
    <b-collapse v-model="isActive">
      <div class="download greenText">
        <ul class="p-1">
          <li v-for="doc in documents" :key="doc.text">
            <a class="services-button-wrapper" :href="doc.url" download target="_blank">
              {{ doc.text }}
              <img src="../assets/img/icons/download.svg" />
            </a>
          </li>
        </ul>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'

export default {
  components: {
    ChevronDownIcon
  },
  props: {
    title: String,
    documents: Array,
    value: Boolean
  },
  data() {
    return {
      isActive: this.value
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
      this.$emit('toggle')
    }
  },
  watch: {
    value(newValue) {
      this.isActive = newValue
    }
  }
}
</script>

<style scoped>
.rotated {
  transform: rotate(180deg);
  transition: transform 0.3s;
}
.chevron-icon {
  transition: transform 0.3s ease;
}

.chevron-rotate {
  transform: rotate(90deg); /* Elforgatás 90 fokkal (balra mutató nyíl) */
}

.download ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.download li {
  padding: 0;
  margin: 10px 0;
  background: #f2f8fa;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 700;
}

.services-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 35px;
  width: 100%;
  text-decoration: none;
  color: inherit;
}

.greenText {
  color: #00903c;
  font-weight: bold;
  font-size: large;
}
.left-span {
  text-align: center; /* A bal oldali span középre igazítása */
  flex-grow: 1; /* Ezzel biztosítjuk, hogy a bal oldali span középen maradjon */
  font-weight: bold;
}

.buttonScroll {
  width: 100%;
  padding: 15px 25px;
  background-color: #f2f8fa !important;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: larger;
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
  border-radius: 12px;
  height: 160px;
  background-color: #f2f8fa;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: 0px;
  transition: opacity 1s ease-out;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: -10px;
  transition: opacity 1s ease-out;
}

/* Csak a mobil képernyőkön (max-width: 767px) történő viselkedés */
@media (max-width: 767px) {
  .left-span {
    font-size: 25px;
  }
}
</style>
